package presentation.screens.business.home

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import cafe.adriel.voyager.core.screen.Screen
import com.friendly.shared.component.layout.VerticalGrid
import common.constants.BusinessMenuConfig
import component.navigation.TopNavBar
import feature.auth.handler.AuthHandler
import feature.business.handler.BusinessHandler
import presentation.screens.business.home.component.headerCard
import presentation.screens.business.home.component.menuCard

class BusinessHomeScreen : Screen {
    @Composable
    override fun Content() {

        var allMenu = BusinessMenuConfig().getMenu()
        val localization = AuthHandler.shared().repository.localization.collectAsState()
        LaunchedEffect(key1 = Unit) {

        }
        Column {
            TopNavBar(
                BusinessHandler.shared().repository.business.value.Name ?: "Home"
            )
            LazyColumn(
                modifier = Modifier
                    .fillMaxSize().padding(bottom = 60.dp)
            ) {
                item {
                    headerCard(menu = allMenu[0])
                    VerticalGrid(
                        columns = 2
                    ) {
                        allMenu[1].sub_menu.forEach { menu ->
                            menuCard(menu)
                        }
                    }
                    headerCard(menu = allMenu[2])
                    VerticalGrid(
                        columns = 2
                    ) {
                        allMenu[3].sub_menu.forEach { menu ->
                            menuCard(menu)
                        }
                    }
                    headerCard(menu = allMenu[4])
                    VerticalGrid(
                        columns = 2
                    ) {
                        allMenu[5].sub_menu.forEach { menu ->
                            menuCard(menu)
                        }
                    }
                }
            }
        }

    }
}





